import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { createValidateSearch } from '@authy/lib-web/routes'

import { developerRootRoute } from '@/tenant/developer/root'

import { SearchSchema, listFailureLogs } from './routeUtils'

const validateSearch = createValidateSearch(SearchSchema)

export const failureLogsRoute = createRoute({
    getParentRoute: () => developerRootRoute,
    path: '/failureLogs',
    component: lazyRouteComponent(() => import('./FailureLogs'), 'FailureLogs'),
    validateSearch,
    loaderDeps: ({ search }) => search,
    loader: ({ deps, abortController }) => listFailureLogs(deps, 0, abortController),
})
